const COMMON_PREFIX = 'COMMON_PREFIX/';

export const TRIGGER_TOAST_ON = `${COMMON_PREFIX}TRIGGER_TOAST_ON`;
export const TRIGGER_TOAST_OFF = `${COMMON_PREFIX}TRIGGER_TOAST_OFF`;
